#if !defined(Sprite3DFrag_lib)
    #define Sprite3DFrag_lib

    #include "Sprite3DCommon.glsl";

#endif // Sprite3DFrag_lib